<style scoped lang="scss">

</style>

<template>
	<div style="display: inline;">
		<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/system/config/role/template/page"
			getKey="rows" :columns="columns">
			<template #conditions>
				<!-- label-width="68px" -->
				<el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
					<el-form-item :label="$t('kehuleixing')">
						<yi_dictionary_select :type="'CUSTOMER_TYPE'" :ids.sync="yt.conditions.customerType">
						</yi_dictionary_select>
					</el-form-item>
					<el-form-item :label="$t('juesemingcheng')" clearable>
						<el-input v-model="yt.conditions.name"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button @click="yt.get(1)" type="primary" plain>
							{{$t('sousuo')}}
						</el-button>
						<el-button @click="yt.clear()">{{$t('chongzhi')}}
						</el-button>
						<yi_curd_expand_button></yi_curd_expand_button>
					</el-form-item>
				</el-form>
			</template>
			<template #buttonsL>
				<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setAddDefaultValue()"
					type="primary">
					{{$t('xinzeng')}}
				</el-button>
			</template>
			<template #buttonsR>
				<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
			</template>
			<template #caozuo="scope">
				<el-row :gutter="10">
					<el-col :span="0.1" v-if="scope.row.admin">
						<!-- <el-button type="text"
							@click="yt.editObj=scope.row;yt.req('POST','/web/system/config/role/template/sync', null,null,'ACTION_SYNC_WARNING')">
							{{$t('tongbuquanxian')}}
						</el-button> -->
						<el-button type="text" @click="openSynchronization(scope.row)">
							{{$t('tongbuquanxian')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" @click="yt.showEditDialog('bianji', scope.row,'w1')">{{$t('bianji')}}
						</el-button>
					</el-col>
					<el-col :span="0.1">
						<el-button type="text" class="font-color-danger"
							@click="yt.remove(scope.row,'/web/system/config/role/template/delete')">{{$t('shanchu')}}
						</el-button>
					</el-col>
				</el-row>
			</template>

			<template #footer>
				<!-- 这里可以在底部填写东西 -->
			</template>
		</yi_curd_table>
		<!-- 新增弹窗 -->
		<el-dialog class="abow_dialog" :show-close="true" :title="$t(yt.editObj.action)"
			:visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body>
			<template v-if="yt.editObj.action == 'xinzeng'">
				<!-- <span>{{yt.editObj.enabled=false}}{{yt.editObj.admin=false}}</span> -->
				<div class="dialog-scroller-form">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('kehuleixing')" required>
							<yi_dictionary_select :type="'CUSTOMER_TYPE'" :ids.sync="yt.editObj.customerType">
							</yi_dictionary_select>
						</el-form-item>
						<el-form-item :label="$t('juesemingcheng')" required>
							<el-input v-model="yt.editObj.name"></el-input>
						</el-form-item>
						<el-form-item :label="$t('kehuguanliyuan')" required>
							<el-select @change="$forceUpdate()" v-model="yt.editObj.admin">
								<el-option :label="$t('shi')" :value="true"></el-option>
								<el-option :label="$t('fou')" :value="false"></el-option>
							</el-select>
						</el-form-item>
						<div>
							<span
								style="font-size: 2px; color: #989898;">{{$t('qingzaixiafangxuanzecaidanyuanniu')}}</span>
						</div>
						<!-- <el-form-item :label="$t('shifoukeyong')" required>
							<el-switch v-model="yt.editObj.enabled"></el-switch>
						</el-form-item> -->
						<el-tabs v-model="current_tab">
							<el-form-item size="mini">
								<el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText">
								</el-input>
							</el-form-item>
							<el-tab-pane label="Web" name="first">
								<el-tree ref="treeWeb" :data="menus[0]" show-checkbox node-key="id"
									:default-expand-all="false" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="App" name="second">
								<el-tree ref="treeApp" :data="menus[1]" show-checkbox node-key="id"
									:default-expand-all="false" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="Pad" name="third">
								<el-tree ref="treePad" :data="menus[2]" show-checkbox node-key="id"
									:default-expand-all="false" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
						</el-tabs>
					</el-form>
				</div>
				<!--注意，el-dialog的slot不能写成#footer-->
				<template slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/system/config/role/template/create',beforeAddOrUpdate)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</template>
			</template>
			<!-- 编辑弹窗 -->
			<template v-if="yt.editObj.action == 'bianji'">
				<!-- <el-tree :data="treeList(1)" show-checkbox node-key="id" :default-expanded-keys="[2, 3]"
					:default-checked-keys="[5]" :props="defaultProps">
				</el-tree>
				 -->
				<div class="dialog-scroller-form">
					<el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
						<el-form-item :label="$t('kehuleixing')" required>
							<yi_dictionary_select :type="'CUSTOMER_TYPE'" :ids.sync="yt.editObj.customerType">
							</yi_dictionary_select>
						</el-form-item>
						<el-form-item :label="$t('juesemingcheng')" required>
							<el-input v-model="yt.editObj.name"></el-input>
						</el-form-item>
						<el-form-item :label="$t('kehuguanliyuan')" required>
							<el-select v-model="yt.editObj.admin">
								<el-option :label="$t('shi')" :value="true"></el-option>
								<el-option :label="$t('fou')" :value="false"></el-option>
							</el-select>
						</el-form-item>
						<div>
							<span
								style="font-size: 2px; color: #989898;">{{$t('qingzaixiafangxuanzecaidanyuanniu')}}</span>
						</div>
						<!-- <el-form-item :label="$t('shifoukeyong')" required>
							<el-switch v-model="yt.editObj.enabled"></el-switch>
						</el-form-item> -->
						<el-tabs v-model="current_tab">
							<el-form-item size="mini">
								<el-input :placeholder="$t('qingshuruguanjianci')" v-model="filterText">
								</el-input>
							</el-form-item>
							<el-tab-pane label="Web" name="first">
								<el-tree ref="treeWeb" :data="menus[0]" show-checkbox node-key="id"
									:default-expand-all="false" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="App" name="second">
								<el-tree ref="treeApp" :data="menus[1]" show-checkbox node-key="id"
									:default-expand-all="false" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
							<el-tab-pane label="Pad" name="third">
								<el-tree ref="treePad" :data="menus[2]" show-checkbox node-key="id"
									:default-expand-all="false" :default-checked-keys="yt.editObj.menuIds"
									class="filter-tree" :filter-node-method="filterNode">
								</el-tree>
							</el-tab-pane>
						</el-tabs>
					</el-form>
				</div>
				<!--注意，el-dialog的slot不能写成#footer-->
				<span slot="footer" class="dialog-footer">

					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button :loading="store.state.global_loading" size="mini"
						@click="yt.req('POST','/web/system/config/role/template/update',beforeAddOrUpdate)"
						type="primary">{{$t('baocun')}}
					</el-button>
				</span>
			</template>

		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		name: 'admin_global_role_list',
		components: {},
		mixins: [],

		data() {
			return {
				filterText: '',
				current_tab: 'first',
				menus: [],
				columns: [{
						label: 'kehuleixing',
						type: 'dictionary',
						key: 'CUSTOMER_TYPE',
						prop: 'customerType',
					},
					{
						label: 'juesemingcheng',
						prop: 'name'
					},
					{
						label: 'shifoukehuguanliyuan',
						prop: 'admin',
						type: 'bool',
						iln18: ['shi', 'fou']
					},
					{
						label: 'chuangjianren',
						prop: 'createByObject.nickname',
					},
					{
						label: 'chuangjianshijian',
						prop: 'createTime',
						type: 'time',
					},
					{
						label: 'gengxinren',
						prop: 'updateByObject.nickname',
					},
					{
						label: 'gengxinshijian',
						prop: 'updateTime',
						type: 'time',
					},
					{
						label: 'caozuo',
						type: 'slot',
						width: 160,
						fixed: 'right',
					},
				]
			};
		},
		created() {

			setTimeout(() => {
				this.yt.get(1)
				// this.getAdminMenus()
			}, 300)

		},
		watch: {
			filterText(val) {
				// 树结构 - 根据关键字搜索
				this.$refs.treeWeb.filter(val);
				this.$refs.treeApp.filter(val);
				this.$refs.treePad.filter(val);
			}
		},
		mounted() {

		},

		destroyed() {},

		computed: {


		},
		activated() {
			this.getAdminMenus()
		},
		methods: {
			openSynchronization(obj) {
				this.$confirm('确认后所有客户的管理员权限都将同步更新</br>是否确定同步', '提示', {
					dangerouslyUseHTMLString: true,
					confirmButtonText: this.$t('quedingtongbu'),
					cancelButtonText: this.$t('quxiao'),
					type: 'warning',
					showCancelButton: true,
					beforeClose: (action, instance, done) => {
					            if (action === 'confirm') {
					              instance.confirmButtonLoading = true;
					              instance.confirmButtonText = '执行中...';
					              setTimeout(() => {
					                done();
					                setTimeout(() => {
					                  instance.confirmButtonLoading = false;
					                }, 300);
					              }, 3000);
					            } else {
					              done();
					            }
					          }
				}).then((res,instance,done) => {
					this.http.post('/web/system/config/role/template/sync', {
						id: obj.id,
					}).then((res) => {
						this.utils.successMessage(this.$t(res.msg))
					}).catch((msg) => {
						this.utils.errorMessage(this.$t(msg))
					})
				}).catch(() => {

				});
			},
			filterNode(value, data) {
				if (!value) return true;
				return data.label.indexOf(value) !== -1;
			},
			setAddDefaultValue() {
				this.yt.editObj.admin = false;
			},

			beforeAddOrUpdate(params) {
				params.menuIds = [...this.$refs.treeWeb.getCheckedKeys(), ...this
					.$refs.treeApp.getCheckedKeys(), ...this.$refs.treePad.getCheckedKeys()
				]
				return params
			},
			getAdminMenus() {
				//先查询出所有平台的菜单
				this.menus = new Array(3)
				for (var i = 0; i < 3; i++) {

					((i) => {
						this.http.get('web/system/auth/menu/treeList', {
							params: {
								platform: i + 2
							}
						}).then(res => {
							this.menus[i] = res.data.rows.map(item => {
								//二级
								let children1
								if (item.children) {
									children1 = item.children.map(item2 => {

										//三级
										let children2
										if (item2.children) {
											children2 = item2.children.map(item3 => {
												const remark = item3.remark ? `(${item3.remark})` : '';
												return {
													label: this.$t(item3.code) + remark,
													id: item3.id
												}
											})
										}
										const remark = item2.remark ? `(${item2.remark})` : '';
										return {
											label: this.$t(item2.code) + remark,
											id: item2.id,
											children: children2
										}
									})
								}

								const remark = item.remark ? `(${item.remark})` : '';
								return {
									label: this.$t(item.code) + remark,
									id: item.id,
									children: children1
								}
							})

						});
					})(i)

				}

			},
		},
	};
</script>
